import { Store } from 'Application/Store/Store'
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine'
import { isVisible } from 'Domain/Scene/Handler/AnimationHandler'

export let keyframe

export const setKeyframe = (value) => { keyframe = value }

const syncMarkRotationWithCamera = (mark, camera) => {
  ['x', 'y', 'z'].forEach(axis => mark.rotation[axis] = camera.rotation[axis])
}

const updateMarkVisibilityForKeyframe = (mark) => {
  const isVisibleAtKeyframe = mark.userData.keyframes.includes(keyframe)
  mark.visible = isVisibleAtKeyframe
  mark.userData.line.visible = isVisibleAtKeyframe
}

const updateMarksVisibility = (camera) => {
  const marks = threeEngine.getMarks()
  if (!marks) return

  const isStrippingVisible = Store.getState().ViewportReducer.strippingVisibility
  marks.visible = isStrippingVisible

  if (!isStrippingVisible) return

  marks.children.forEach(group => {
    if (!group.children) return
    group.children.forEach(mark => {
      if (mark.type !== 'Mesh') return
      syncMarkRotationWithCamera(mark, camera)
      updateMarkVisibilityForKeyframe(mark)
    })
  })
}

const updateStrippingsVisibility = () => {
  const strippings = threeEngine.getStrippings()
  if (!strippings) return

  const isStrippingVisible = Store.getState().ViewportReducer.strippingVisibility

  strippings.forEach(stripping => {
    if (!isStrippingVisible) {
      stripping.visible = false
      return
    }
    stripping.visible = isVisible(stripping.userData, keyframe)
  })
}

const updateAttachmentsVisibility = () => {
  const allAttachments = threeEngine.getAllAttachments()
  if (!allAttachments) return

  const isAttachmentVisible = Store.getState().ViewportReducer.attachmentVisibility

  allAttachments.forEach(attachment => {
    if (!isAttachmentVisible) {
      attachment.visible = false
      return
    }
    attachment.visible = isVisible(attachment.userData, keyframe)
  })
}

export const updateElementsVisibility = (camera) => {
  updateMarksVisibility(camera)
  updateStrippingsVisibility()
  updateAttachmentsVisibility()
}
